export default __webpack_public_path__ + "static/media/gluten-free.58a3f90e.png";